import React, { useState } from 'react';
import './profile-calc.scss';

interface Category {
  id: string;
  label: string;
}

const categories: Category[] = [
  {id: "2",  label:"Adult sites"},
  {id: "3",  label:"Mixed adult content"},
  {id: "4",  label:"Hate speech & extremist content"},
  {id: "5",  label:"Violence}, weapons & military"},
  {id: "6",  label:"Self harm"},
  {id: "7",  label:"Body Art"},
  {id: "8",  label:"Religious material"},
  {id: "9",  label:"Alternative religions & sects"},
  {id: "10", label:"Astrology, horoscopes & paranormal"},
  {id: "11", label: "Criminality, hacking etc."},
  {id: "12", label: "Piracy & Copyright Theft"},
  {id: "13", label: "Gambing sites"},
  {id: "14", label: "Illegal drugs"},
  {id: "15", label: "Tobacco"},
  {id: "16", label: "Sex eduction"},
  {id: "17", label: "Womens health"},
  {id: "18", label: "Mens Health"},
  {id: "19", label: "Social networking"},
  {id: "20", label: "Online Shopping"},
  {id: "21", label: "Movies & TV"},
  {id: "22", label: "Entertainment News & Celebrity Sites"},
  {id: "23", label: "Games"},
  {id: "24", label: "Banking"},
  {id: "25", label: "Financial sites"},
  {id: "26", label: "Cartoons}, Anime & comicbooks"},
  {id: "27", label: "Music & Video Streaming"},
  {id: "28", label: "Photo sharing & Image Search"},
  {id: "29", label: "Humour"},
  {id: "30", label: "Sports sites"},
  {id: "31", label: "Blogs"},
  {id: "32", label: "Chat sites"},
  {id: "33", label: "Forums"},
  {id: "34", label: "Webmail, messaging & VOIP sites"},
  {id: "35", label: "School cheating"},
  {id: "36", label: "Job search sites"},
  {id: "37", label: "Private and parked sites"},
  {id: "38", label: "Filehosting sites"},
  {id: "39", label: "Marketingware"},
  {id: "40", label: "Fraudulent advertisements"},
  {id: "41", label: "Redirect sites & Botnets"},
  {id: "42", label: "Phishing"},
  {id: "43", label: "Remote access & antivirus"},
  {id: "44", label: "Malware & anonymizers"},
  {id: "45", label: "URL Shorteners & spam sites"},
];

export function ProfileCalc() {
  const [binary, setBinary] = useState('0'.repeat(categories.length));
  const [base36, setBase36] = useState('');

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const categoryId = event.target.value;
    const checked = event.target.checked;
    setBinary((prevBinary) => {
      let updatedBinary = prevBinary;
      if (checked) {
        // Set the corresponding bit to 1
        updatedBinary = setBit(prevBinary, +categoryId - 1, '1');
      } else {
        // Set the corresponding bit to 0
        updatedBinary = setBit(prevBinary, +categoryId - 1, '0');
      }
      return updatedBinary;
    });
  };

  const handleBinaryToBase36 = () => {
    const base36Value = binaryToProfile(binary);
    setBase36(base36Value);
  };

  const handleBase36ToBinary = () => {
    const binaryValue = base36ToBinary(base36);
    setBinary(binaryValue);
  };

  const setBit = (binaryString: string, index: number, bit: string) => {
    return binaryString.substring(0, index) + bit + binaryString.substring(index + 1);
  };

  return (
    <section id="profile-calc">
      <legend>Binary to Base36 Conversion</legend>
      <div className="categories-container">
        <div className="form-group">
          <input
            type="text"
            value={binary}
            onChange={(event) => setBinary(event.target.value)}
            maxLength={categories.length}
            width="200px"
            pattern="[0-1]*"
            title="Please enter a binary value (0 or 1)"
            readOnly
          />
          <button type="button" onClick={handleBinaryToBase36}>
            Convert to Base36
          </button>
        </div>
        <div className="form-group">
          <input
            type="text"
            value={base36}
            onChange={(event) => setBase36(event.target.value)}
          />
          <button type="button" onClick={handleBase36ToBinary}>
            Convert to Binary
          </button>
        </div>
        <hr></hr>
        {categories.map((category) => (
          <div className="form-check" key={category.id}>
            <input
              className="form-check-input"
              type="checkbox"
              value={category.id}
              onChange={handleCheckboxChange}
              id={`category-${category.id}`}
              checked={binary.charAt(+category.id - 1) === '1'}
            />
            <label className="form-check-label" htmlFor={`category-${category.id}`}>
              {category.label}
            </label>
          </div>
        ))}
      </div>
    </section>
  );
}


function binaryToProfile(binaryString: string) {
  const binaryStringReverse = binaryString.split('').reverse().join('');
  const decimalValue = parseInt(binaryStringReverse, 2);
  const profile = decimalValue.toString(36);
  return profile;
}

function base36ToBinary(base36String: string) {
  const decimalValue = parseInt(base36String, 36);
  const binaryString = decimalValue.toString(2);
  return binaryString.split('').reverse().join('');
}